<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>{{isStep}}. Ad Hoc Charges </v-card-title>

        <v-card-text>
          <template v-if="adhoc.length">
            <template v-for="(item, index) in adhoc">
              <div :key="index" class="d-flex body--text">
                <span>{{item.name}} x {{ item.quantity }} {{item.price * item.quantity | formatCurrency}}</span>
              </div>
            </template>
          </template>

          <template v-else>
            <div>There are no required charges for the selected tariff.</div>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['isStep', 'adhoc'],
}
</script>

<style lang="scss" scoped></style>